<template>
  <div class="popup" v-cloak v-if="deleteSelectedTaskShow">
    <div class="content" id="deleteTask">
      <div class="title">
        {{$t('language.common.delete')}}
        <div class="icon white-close dialog-close" @click="cancel()"></div>
      </div>
      <div class="delete-body">
        <div class="delete-info">
          <div class="task-popup-notice"></div>
          <div class="delete-info-tips">
            <strong v-html="$t('language.popup.deleteBatchPopup.tips1',{num:deleteList.length})"></strong>
            <br>
            {{$t('language.popup.deleteBatchPopup.tips2')}}
          </div>
        </div>
        <div class="delete-task-button">
          <button class="white-button" style="margin-right:5px;" @click="cancel()">{{$t('language.common.cancel')}}</button>
          <button @click="deleteSelectedTask()">{{$t('language.common.delete')}}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import commonUtils from "@/js/workspace/common_util.js";
  import taskListUtils from "@/js/workspace/task_list_util.js";
  export default {
    props: ['deleteList'],
    data() {
      return {
        deleteSelectedTaskShow: false,
      }
    },
    methods: {
      cancel() {
          this.deleteSelectedTaskShow = false;
          this.$parent.showBatchDel = true;
          this.$parent.showDelBtn = true;
      },
      deleteSelectedTask() { //删除选中的任务项
        let that = this;
        that.$parent.eidtTaskFlag = false;
        that.deleteSelectedTaskShow = false;
        that.$parent.deleteloading = true;

        let batchDelItems = [];
        let realtimeDelItems = [];
        let businessDelItems = [];

        $.each(this.deleteList, function(i, selectItemId) {
          let selectItem = that.$parent.taskListOriginal.find(item => item.id === selectItemId);
          let deleteData = that.deleteInfo(selectItem);
          if (selectItem.branchType != 'realtime') {
            if (selectItem.type == 6) { //如果想删除任务的类型是备份任务
              if (selectItem.status == 'Restoring' || selectItem.status == 'Running' || selectItem.status ==
                'Waiting') {
                deleteData.status = selectItem.status;
                batchDelItems.push(deleteData);
                return;
              }
            }
            if (selectItem.lowerType == 104) {
              deleteData = {
                id: selectItem.id
              }
              businessDelItems.push(deleteData);
              return;
            }
            batchDelItems.push(deleteData);
          } else {
            realtimeDelItems.push(deleteData);
          }
        });
        let batchDelData = {
          ud: commonUtils.getUser().id,
          deleteItems: {
            realtime: realtimeDelItems,
            business: businessDelItems,
            others: batchDelItems,
          },
          type: 100,//批量删除
        }
        that.Utils.doTasksRequest("delete_batch", batchDelData).then(res => { //删除任务
        console.log(res)
              if (res.status == 200) {
                that.deleteTaskRespone(batchDelItems);
              } else {
                that.$parent.deleteloading = false;
                that.$toast({
                  text: that.$t('language.exception.' + res.reason),
                  type: 'fail',
                  idValue: "rightBodyList"
                });
              }
            }, err => {
              that.$toast({
                text: err,
                type: 'fail',
                idValue: "rightBodyList"
              });
        });
      },
      deleteInfo(selectItem) { //封装删除信息
        let taskType;
        let deleteData;
        // if (selectItem.groupId) {
        //   deleteData = new taskListUtils.deleteTaskData(commonUtils.getUser().id, selectItem.type, null, selectItem
        //     .groupId);
        // } else {
        //   deleteData = new taskListUtils.deleteTaskData(commonUtils.getUser().id, selectItem.type, selectItem.id, null);
        // }
        if(selectItem.isMultiTask&&selectItem.type!=6) {
          deleteData = new taskListUtils.deleteTaskData(commonUtils.getUser().id, selectItem.type, null, selectItem.id);
        }else {
          deleteData = new taskListUtils.deleteTaskData(commonUtils.getUser().id, selectItem.type, selectItem.id, null);
        }
        deleteData.taskType = selectItem.lowerType;
        console.log(selectItem)
        return deleteData;
      },
        //删除数据成功后的操作
        deleteTaskRespone(selectItems) {
            this.$emit("refresh-all",true);
            this.$parent.checkDeleteList = [];
            this.$toast({
                text: this.$t('language.common.delete') + this.$t('language.common.success'),
                type: 'notice',
                idValue: "rightBodyList"
            });
        }

    }

  }
</script>

<style scoped>
  #deleteTask {
    width: 380px;
    /*no*/
    height: 200px;
    /*no*/
  }

  .delete-body {
    width: 100%;
    /*no*/
    color: #6f7886;
    padding-left: 20px;
    /*no*/
    box-sizing: border-box;
  }

  .delete-info {
    width: 100%;
    position: relative;
    top: 20px;
    /*no*/
    float: left;
    display: flex;
  }

  .delete-info-tips {
    font-family: Microsoft YaHei UI;
    font-size: 14px;
    /*no*/
    line-height: 20px;
    /*no*/
    letter-spacing: 0em;
    margin-left: 20px;
    /*no*/
    color: #000;
    width: 280px;
    /*no*/
    height: 80px;
    /*no*/
  }

.delete-info-tips /deep/ span {
    color: #5562B4;
  }

  .delete-task-button {
    bottom: 20px;
    /*no*/
    right: 20px;
    /*no*/
    position: absolute;
  }

  button {
    padding: 0 30px !important;
    /*no*/
  }

  .task-popup-notice {
    margin-left: 8px;
    /*no*/
  }
</style>



// WEBPACK FOOTER //
// src/components/popup/task_list_popups/delete_selected_tasks_popups.vue